import React from 'react';

import algoliasearch from "algoliasearch/lite";
import { InstantSearch } from "react-instantsearch-hooks-web";
import DonwloadUsersListByState from './DonwloadUsersList_byState';

const searchClient = (() => {
  if (!process.env.REACT_APP_ALGOLIA_APP_ID) {
    throw new Error(
      "REACT_APP_ALGOLIA_APP_ID environment variable not defined",
    );
  }
  if (!process.env.REACT_APP_ALGOLIA_API_KEY) {
    throw new Error(
      "REACT_APP_ALGOLIA_API_KEY environment variable not defined",
    );
  }

  return algoliasearch(
    process.env.REACT_APP_ALGOLIA_APP_ID,
    process.env.REACT_APP_ALGOLIA_API_KEY,
  );
})();
const DownloadCSVByState = () => {
    return (
        <div>
        <InstantSearch searchClient={searchClient} indexName={"UserQueries"}>
          <div className='bg-white h-[100vh] '>

        
            <DonwloadUsersListByState />
              </div>
             </InstantSearch>
            
        </div>
    );
}

export default DownloadCSVByState;
